export default __webpack_public_path__ + "static/media/editActionsIcon.9e3b512b.svg";